import { loadPoptip } from '@visactor/vrender-components';

export const registerPoptip = () => {
  loadPoptip();
};
